// © Sitecore Corporation A/S. All rights reserved. Sitecore® is a registered trademark of Sitecore Corporation A/S.
import { ErrorMessages } from '../consts';
/**
 * Validates the core settings to ensure they meet required criteria.
 *
 * This function validates the provided core settings object to ensure that essential properties
 * such as "sitecoreEdgeContextId," and "siteName" meet specific criteria and are not empty.
 *
 * @param settings - The core settings object to validate.
 * @throws Error with specific error codes if any required property is missing or empty.
 */
export function validateSettings(settings) {
    const { sitecoreEdgeContextId, siteName, sitecoreEdgeUrl } = settings;
    if (!sitecoreEdgeContextId || sitecoreEdgeContextId.trim().length === 0)
        throw new Error(ErrorMessages.MV_0001);
    if (!siteName || siteName.trim().length === 0)
        throw new Error(ErrorMessages.MV_0002);
    if (sitecoreEdgeUrl !== undefined)
        try {
            new URL(sitecoreEdgeUrl);
        }
        catch (e) {
            throw new Error(ErrorMessages.IV_0001);
        }
}
